import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/http";
import ActivePlanPublicView from "./ActivePlanPublicView";
import PrintActiveCarePlan from "./PrintActiveCarePlan";

export default function PublicCarePlan({ mode }) {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    if (!publicId) return;
    axiosInstance
      .get(`/public/careplan/${publicId}/`)
      .then(({ data }) => setPlan(data))
      .catch(() => navigate("/404"));
  }, [publicId, navigate]);

  useEffect(() => {
    if (!plan || mode !== "digital" || !publicId) return;

    // dev-safety: prevent multiple posts on strict-mode remounts
    const guardKey = `posted_view_${publicId}`;
    if (sessionStorage.getItem(guardKey)) return;

    const fire = () => {
      if (document.visibilityState !== "visible") return;
      sessionStorage.setItem(guardKey, "1");
      axiosInstance
        .post(
          `/public/careplan/${publicId}/view/`,
          { view_nonce: plan.view_nonce } // body
        )
        .catch(() => {});
      document.removeEventListener("visibilitychange", fire);
    };

    if (document.visibilityState === "visible") fire();
    else document.addEventListener("visibilitychange", fire);

    return () => document.removeEventListener("visibilitychange", fire);
  }, [plan, mode, publicId]);

  if (!plan) return <div>Loading…</div>;

  // Pass the *entire* plan object down.  Both children expect the same shape.
  return mode === "digital" ? (
    <ActivePlanPublicView plan={plan} />
  ) : (
    <PrintActiveCarePlan plan={plan} />
  );
}
